// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getRemoteConfig } from "firebase/remote-config";
import { initializeFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getStorage, connectStorageEmulator } from "firebase/storage";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import { getDatabase } from "firebase/database";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyBd4z0wbFbyYOhqzOwO63M38KkkBJ21pcs",
    authDomain: "www.bostonhoops.org",
    projectId: "bos-hoops",
    storageBucket: "bos-hoops.firebasestorage.app",
    messagingSenderId: "149167677795",
    appId: "1:149167677795:web:34f91531135c6cb9547356",
    measurementId: "G-223110YFCX"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const remoteConfig = getRemoteConfig(app);
// `ignoreUndefinedProperties` lets writes carry optional DTO fields as
// `undefined` without Firestore throwing; undefined fields are simply omitted.
// `experimentalForceLongPolling` avoids the default WebChannel transport, which
// hangs ~30s before falling back on some mobile/WiFi/proxy networks
// (firebase-js-sdk#8510), stalling the first server-confirmed snapshot.
export const firestore = initializeFirestore(app, {
    ignoreUndefinedProperties: true,
    experimentalForceLongPolling: true,
});
export const storage = getStorage(app);
export const functions = getFunctions(app);
export const database = getDatabase();

// Local development against the Firebase Local Emulator Suite. Opt in by
// setting REACT_APP_USE_EMULATORS=true (see `npm run dev:hoops-emulators`).
// Without it, the app talks to the live `bos-hoops` project as before.
if (process.env.REACT_APP_USE_EMULATORS === "true") {
    connectAuthEmulator(auth, "http://localhost:9099", { disableWarnings: true });
    connectFirestoreEmulator(firestore, "localhost", 8080);
    connectStorageEmulator(storage, "localhost", 9199);
    connectFunctionsEmulator(functions, "localhost", 5001);
    // eslint-disable-next-line no-console
    console.info("[firebase] Connected to local emulators (auth:9099, firestore:8080, storage:9199, functions:5001)");
}

remoteConfig.settings.minimumFetchIntervalMillis = 36000;


